import { apiClient, ApiError } from './apiClient';

export interface Entity {
  ID: string;
  UserId: string;
  Role: string;
  AccountName: string;
  MohaAccountNumber: string;
  MohaEuaBalance: number;
  TraderName?: string;
  TraderEmail?: string;
  ReportEmail?: string;
  UpdatedAt: string;
  LinkedUsers?: string[];
  DataProviders?: string[];
  // Per-account opt-out for the FuelEU section on voyage reports. Tri-state:
  // undefined (unset) is treated as ON, matching the backend *bool default.
  FuelEUOnReports?: boolean;
}

export interface CreateEntityRequest {
  UserID: string;
  Role: string;
  AccountName: string;
  MohaAccountNumber: string;
  MohaEuaBalance: number;
  TraderName?: string;
  TraderEmail?: string;
  ReportEmail?: string;
  DataProviders?: string[];
}

export async function getEntities(userId?: string | null): Promise<Entity[] | ApiError> {
  const qs = userId ? `?userId=${encodeURIComponent(userId)}` : '';
  return apiClient.get<Entity[] | ApiError>(`/entities${qs}`);
}

export async function createEntity(payload: CreateEntityRequest) {
  return apiClient.post<{ message: string }>('/entities', payload);
}

export async function updateEntity(entityId: string, payload: Partial<Entity>) {
  return apiClient.put<{ message: string }>(`/entities/${entityId}`, payload);
}

export async function deleteEntity(entityId: string) {
  return apiClient.delete<{ message: string }>(`/entities/${entityId}`);
}

export async function getAvailableDataProviders(): Promise<{ providers: string[] }> {
  return apiClient.get<{ providers: string[] }>('/entities/data-providers');
}
